module.exports = __webpack_public_path__ + "static/media/hub-inventory-empty.68d5af9b.svg";